import { Injectable } from '@angular/core';
import { Basket, InterfaceBasketItem } from '../models/basket';
import { BehaviorSubject } from 'rxjs';
import { TimeZoneService } from 'src/app/services/timezone.service';

enum BasketItemTypes {
  COURSE = 'course',
  STREAM = 'stream'
}

@Injectable({
  providedIn: 'root'
})

export class BasketService {
  public basket = new BehaviorSubject<Basket>(new Basket({}));
    // TimeZone related configuration
    public DefaultTimeZone:boolean = true;
    public USATimeZone:boolean = false;
    public AustraliaTimeZone:boolean = false;
    public AucklandTimeZone:boolean = false;
    public HongKongTimeZone:boolean = false;
    public EUTimeZone:boolean = false;
    public CanadaTimeZone:boolean = false;
    public UAETimeZone:boolean = false;

  constructor(private timezoneService: TimeZoneService) {
    this.basket.next(this.getBasket());
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();
  }

  public exchangeCalculator(amount)
  {
      if(this.AustraliaTimeZone){
          let rate = 2.01;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }
      if(this.AucklandTimeZone){
          let rate = 2.32;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }
      if(this.HongKongTimeZone){
          let rate = 10.23;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }
      if(this.USATimeZone){
          let rate = 1.31;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }
      if(this.EUTimeZone){
          let rate = 1.13;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }
      if(this.CanadaTimeZone){
          let rate = 1.84;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }
      if(this.UAETimeZone){
          let rate = 4.83;
          amount = (rate * parseInt(amount)).toFixed(2);
          return Math.round(Number(amount));
      }

      return amount;
  }

  public getBasketTax(tax)
  {
      if(this.timezoneService.checkDefaultTimeZone() && !this.EUTimeZone) return tax;

      return 0;
  }

    public getCurrencyISOCode() {
      let currencyISOCode = 'GBP';
        if(this.AustraliaTimeZone){
            currencyISOCode = 'AUD';
        }
        if(this.AucklandTimeZone){
            currencyISOCode = 'NZD';
        }
        if(this.HongKongTimeZone){
            currencyISOCode = 'HKD';
        }
        if(this.USATimeZone){
            currencyISOCode = 'USD';
        }
        if(this.EUTimeZone){
            currencyISOCode = 'EUR';
        }
        if(this.CanadaTimeZone){
            currencyISOCode = 'CAD';
        }
        if(this.UAETimeZone){
            currencyISOCode = 'AED';
        }

        return currencyISOCode;
    }


    public getSubTotal(){
        let basket = this.getBasket();
        let sub_total = 0;

        if(!this.DefaultTimeZone || this.EUTimeZone) {
            basket.items.forEach(item=>{
                let price = Math.round(this.exchangeCalculator(item.item.price) / 100) * 100;
                sub_total += (price * item.quantity);
            });
            return sub_total;
        }

        basket.items.forEach(item=>{
            let price = Math.round(Number(item.item.price) / 100);
            sub_total+=(price*item.quantity);
        });

        return sub_total * 100;
    }

  public getTotal(dv:number=0){

    let basket = this.getBasket();

    if(!this.DefaultTimeZone || this.EUTimeZone){
      return this.getSubTotal();
    }

    if(dv) basket.discount_value=dv/100;
    let total = this.getSubTotal()-(basket.discount_value)+this.getTax(dv);

    if (total < 0) total = 0;

    return total;
  }

  public getTax(dv:number=0){
    let basket = this.getBasket();
    if(dv) basket.discount_value=dv/100;
    // let total = 0;
    let total = this.getSubTotal()-(basket.discount_value);
    if (total < 0) total=0;

    // basket.items.forEach(item=>{
    //   total+=item.item.price*item.quantity;
    // })
    let tax = (total/100)*basket.tax_rate;
    if(this.EUTimeZone){
        tax = 0;
    } else if(!this.DefaultTimeZone){
        tax = this.exchangeCalculator(tax);
    }

    return tax;
  }

  public getDiscount(){

    let basket = this.getBasket();
    if(basket.discount_amount){

      if (basket.discount_stream_id) {
        basket.items.forEach(item=>{
          if(item.item.id==basket.discount_stream_id){
            // console.log(item.item.id, basket.discount_stream_id);
            if(basket.discount_type=='amount'){
              basket.discount_value=basket.discount_amount*100;
              // return basket.discount_value;
            }
            if(basket.discount_type=='percent'){
              //console.log(parseInt(basket.discount_amount));
              basket.discount_value=(item.item.price / 100) * basket.discount_amount;
              //console.log(item.item.price, basket.discount_amount, basket.discount_value);
              // return basket.discount_value;
            }
          }
        });
      } else {
        if(basket.discount_type=='amount') {
          basket.discount_value=basket.discount_amount*100;
        }
        if(basket.discount_type=='percent'){
          let subtotal = this.getSubTotal();
          basket.discount_value=(subtotal / 100) * basket.discount_amount;
          // return basket.discount_amount;
        }
      }
      basket.tax=this.getTax(basket.discount_value);
      basket.total=this.getTotal(basket.discount_value);

      this.saveBasket(basket);
    }
    return 0;
  }


 public saveBasket(basket: Basket) {
  localStorage.setItem('basket', JSON.stringify(basket));
  basket.tax=this.getTax();
  basket.sub_total=this.getSubTotal();
  localStorage.setItem('basket', JSON.stringify(basket));
  this.basket.next(basket);
 }

 public getBasket(): Basket {
   if (localStorage.getItem('basket')) {
    return JSON.parse(localStorage.getItem('basket'));
   }
   return new Basket({});
 }

 public addDiscount(type:string, amount:number, label:string, stream_id:number){
   this.removeDiscounts();
  const basket = this.basket.value;
  basket.discount_type=type;
  basket.discount_amount=amount;
  basket.discount_label=label;
  basket.discount_stream_id=stream_id;
  this.saveBasket(basket);
  this.getDiscount();
  // this.basket.next(this.getBasket());
 }

 public removeDiscounts(){
  const basket = this.basket.value;
  basket.discount_type=null;
  basket.discount_amount=0;
  basket.discount_label=null;
  basket.discount_stream_global=0;
  basket.discount_stream_id=0;
  basket.discount_value=0;
  this.saveBasket(basket);
  basket.tax=this.getTax();
  this.saveBasket(basket);
 }

 public add(type: BasketItemTypes, item: any, quantity:number, quiet?: boolean) {
  const basket = this.basket.value;
  const newItem = new InterfaceBasketItem;
  quantity = Math.floor(quantity);
  if(quantity<1){
    quantity = 1;
  }
  let existingItem =[];
  if(basket.items.length!=0){
    existingItem = basket.items.filter(items => items.type === type && items.item.id === item.id);
  }

  if (type=='stream') item.title=item.name;

  if (existingItem.length === 0) {
    newItem.item = item;
    newItem.type = type;
    newItem.quantity = quantity;
    basket.items.push(newItem);

  }

  this.saveBasket(basket);
  this.basket.next(basket);
  if (quiet !== true) {
    }

}

 public remove(type: BasketItemTypes, item: any, quiet?: boolean) {
  const basket = this.basket.value;

  const existingItem = basket.items.filter(i => {
    return i.type === type && i.item.id === item.item.id
  });

  existingItem[0].quantity --;
  basket.items = basket.items.filter(items => {
    return items.quantity > 0
  });

  this.saveBasket(basket);
  this.basket.next(basket);
  if (quiet !== true) {

    }
 }

 public clear() {
   localStorage.removeItem('basket');
   this.basket.next(new Basket({}));

    }

}
